// eslint-disable-next-line import/no-extraneous-dependencies
import { gql } from '@apollo/client';

export const CLIENT_LOGIN = gql`
  query ClientLogin($email: String, $password: String, $recaptcha: String) {
    clientLogin(email: $email, password: $password, recaptcha: $recaptcha) {
      id
      email
      role
      firstName
      lastName
      avatarUrl
      phone
      department
      token
      createdAt
      updatedAt
      displayName
    }
  }
`;
export const CLIENT_BY_ID = gql`
  query ClientByID($id: String) {
    clientByID(id: $id) {
      id
      email
      role
      firstName
      lastName
      displayName
      avatarUrl
      phone
      department
      createdAt
      updatedAt
      customer
    }
  }
`;
export const CLIENTS_PAGINATED_LIST = gql`
  query ClientsPaginatedList(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $name: String
    $type: String
  ) {
    usersPaginatedList(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      name: $name
      type: $type
    ) {
      filteredCount
      users {
        id
        email
        role
        firstName
        lastName
        displayName
        avatarUrl
        phone
        department
        createdAt
        updatedAt
        customer
      }
    }
  }
`;

export const REQUEST_BY_ID = gql`
  query RequestById($id: ID!) {
    requestById(id: $id) {
      id
      customer
      userId
      user {
        firstName
        lastName
        id
      }
      mediator
      dateOfRequestCompletion
      applicantFirstName
      applicantLastName
      applicantEmail
      applicantPhone
      applicantOtherEmail
      structurePavilionAddress
      requestId
      operationalUnits
      status
      expectedDuration
      floor

      assignedUser
      office
      dateOfIntervention
      mediationType
      mediationCategory
      patientIndication
      targetLanguage
      motivation
      otherMotivation
      notes
      createdAt
      updatedAt
      applicantOtherPhone
      mediatorInfo
      preferredMediator
      patientFirstName
      patientLastName
    }
  }
`;
export const REQUESTS_PAGINATED_LIST = gql`
  query RequestsPaginatedList(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $requestId: String
    $customer: String
    $status: [String!]!
    $createdAt: [String]
    $dateOfIntervention: [String]
  ) {
    requestsPaginatedList(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      search: $requestId
      customer: $customer
      status: $status
      createdAt: $createdAt
      dateOfIntervention: $dateOfIntervention
    ) {
      filteredCount
      requests {
        id
        customer

        user {
          firstName
          lastName
          id
        }
        dateOfRequestCompletion
        applicantFirstName
        applicantLastName
        applicantEmail
        applicantPhone
        applicantOtherEmail
        structurePavilionAddress
        requestId
        operationalUnits
        status
        mediator
        expectedDuration
        floor
        dateOfIntervention
        mediationType
        patientIndication
        targetLanguage
        motivation
        otherMotivation
        notes
        createdAt
        updatedAt
        mediationCategory
        applicantOtherPhone
        mediatorInfo
        preferredMediator
        patientFirstName
        patientLastName
        amount
        assignedUser
        minutes
        formUrl
      }
    }
  }
`;

// Intranet Queries
export const GET_BOOKING_BY_REQUEST_ID = gql`
  query GetBookingByRequestId($requestId: ID!) {
    getBookingByRequestId(requestId: $requestId) {
      id
      requestId
      mediatorId
      status
      deliveryDate
      language
      minutes
      formUrl
      amount
      additionalMinutes
      notes
      createdAt
      updatedAt
      firstName
      lastName
      autoConfirmation
      mediationType
      addedBy {
        firstName
        lastName
      }
    }
  }
`;
export const INTRANET_USER_LOGIN = gql`
  query IntranetLogin($email: String, $password: String, $recaptcha: String) {
    intranetLogin(email: $email, password: $password, recaptcha: $recaptcha) {
      id
      email
      role
      firstName
      lastName
      displayName
      avatarUrl
      phone
      department
      type
      token
      createdAt
      updatedAt
      customer
    }
  }
`;
export const MEDIATOR_BY_ID = gql`
  query MediatorById($id: String!) {
    mediatorById(id: $id) {
      id
      firstName
      lastName
      email
      phone
      address
      domicileAddress
      sourceLanguage1
      targetLanguage1
      targetLanguageOne
      sourceLanguage2
      targetLanguage2
      targetLanguageTwo
      sourceLanguage3
      targetLanguage3
      targetLanguageThree
      sourceLanguage4
      targetLanguage4
      targetLanguageFour
      cv
      zipCode
      fiscalCode
      IBAN
      personalCalendar
      mediationCard
      notes
      createdAt
      updatedAt
      isActive
      inactiveReason
      role
      token
      monday_time_slots
      tuesday_time_slots
      wednesday_time_slots
      thursday_time_slots
      friday_time_slots
      saturday_time_slots
      sunday_time_slots
      availableForEmergencies
      availableOnHolidays
      priority
    }
  }
`;
export const MEDIATORS_LIST = gql`
  query MediatorsPaginatedList(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $name: String
    $isActive: Boolean
    $targetLanguage: String
  ) {
    mediatorsPaginatedList(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      name: $name
      isActive: $isActive
      targetLanguage: $targetLanguage
    ) {
      filteredCount
      mediators {
        id
        firstName
        lastName
        email
        phone
        address
        sourceLanguage1
        targetLanguage1
        targetLanguage2
        targetLanguage3
        targetLanguage4
        cv
        mediationCard
        deliveries {
          id
          duration
          deliveryDate
        }
        isActive
        inactiveReason
      }
    }
  }
`;

// Mediator Queries

export const MEDIATOR_LOGIN = gql`
  query MediatorLogin($email: String!, $password: String!) {
    mediatorLogin(email: $email, password: $password) {
      id
      firstName
      lastName
      email
      phone
      address

      sourceLanguage1
      targetLanguage1
      cv

      mediationCard
      notes

      createdAt
      updatedAt
      isActive
      role
      token
    }
  }
`;

export const GET_BOOKINGS_BY_MEDIATOR = gql`
  query GetBookingsByMediator(
    $mediatorId: String
    $status: [String]
    $request: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    getBookingsByMediator(
      mediatorId: $mediatorId
      status: $status
      request: $request
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      filteredCount
      bookings {
        id
        requestId
        mediatorId
        status
        notes
        deliveryDate
        language
        minutes
        amount
        createdAt
        formUrl
        updatedAt
        firstName
        lastName
        request
      }
    }
  }
`;
export const GET_BOOKING = gql`
  query GetBooking($id: ID!) {
    getBooking(id: $id) {
      id
      requestId
      mediatorId
      status
      notes
      deliveryDate
      language
      minutes
      amount
      createdAt
      updatedAt
      firstName
      lastName
      request
      formUrl
    }
  }
`;

export const GET_REQUEST_STATUS_BY_CLIENT = gql`
  query GetRequestStatusByClient($year: String) {
    getRequestStatusByClient(year: $year)
  }
`;
export const GET_REQUEST_STATUS_FOR_INTRANET = gql`
  query GetRequestStatusForIntranet($year: String) {
    getRequestStatusForIntranet(year: $year)
  }
`;
export const GET_REQUESTS_BY_MONTH = gql`
  query GetRequestsByMonth($year: String) {
    getRequestsByMonth(year: $year)
  }
`;

export const GET_USERS_LIST = gql`
  query GetUsersList($type: String) {
    getUsersList(type: $type)
  }
`;

export const ALL_MEDIATOR_LIST = gql`
  query MediatorList {
    mediatorList {
      id
      firstName
      lastName
      email
    }
  }
`;
export const GET_BOOKING_BY_LINGUIST = gql`
  query GetRequestsByMonth($year: String) {
    getRequestsByMonth(year: $year)
  }
`;
export const GET_MONTH_WITHOUT_INVOICE = gql`
  query GetRequestsByMonth($year: String) {
    getRequestsByMonth(year: $year)
  }
`;

export const GET_MEDIATORS_LIST_WITH_BOOKING = gql`
  query CompletedBookingsByMediators($month: String!, $year: String!, $offset: Int!, $limit: Int!) {
    completedBookingsByMediators(month: $month, year: $year, offset: $offset, limit: $limit)
  }
`;
export const GET_INVOICE = gql`
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      invoiceId
      invoiceYear
      invoiceMonth
      mediatorId
      status
      invoiceFrom
      invoiceTo
      createdDate
      dueDate
      withholdingTax
      total
      netTotal
      grandTotal
      notes
      items
      createdAt
      updatedAt
    }
  }
`;

export const GET_INVOICES = gql`
  query GetInvoices(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $search: String
    $createdDate: [String]
    $status: [String]
  ) {
    getInvoices(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      search: $search
      createdDate: $createdDate
      status: $status
    ) {
      filteredCount
      invoices {
        id
        status
        invoiceId
        invoiceYear
        invoiceMonth
        mediatorId
        invoiceFrom
        invoiceTo
        createdDate
        dueDate
        withholdingTax
        total
        netTotal
        grandTotal
        items
        createdAt
        updatedAt
      }
    }
  }
`;
export const GET_LANGUAGES = gql`
  query Languages($offset: Int, $limit: Int, $order: String, $orderBy: String, $search: String) {
    languages(offset: $offset, limit: $limit, order: $order, orderBy: $orderBy, search: $search) {
      filteredCount
      languages {
        id
        language_code
        language_name
        created_at
        updated_at
      }
    }
  }
`;

export const ALL_LANGUAGES = gql`
  query AllLanguages {
    allLanguages {
      id
      language_name
    }
  }
`;

export const GET_TRANSLATION_ORDERS = gql`
  query TranslationOrders(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $search: String
  ) {
    translationOrders(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      search: $search
    ) {
      filteredCount
      translationOrders {
        id
        mediatorId
        deliveryDate
        amount
        orderNo
        title
        pages
        department
        created_at
        updated_at
        mediator
      }
    }
  }
`;
export const GET_TRANSLATION_ORDER = gql`
  query TranslationOrder($id: ID!) {
    translationOrder(id: $id) {
      id
      mediatorId
      deliveryDate
      amount
      orderNo
      title
      pages
      department
      created_at
      updated_at
      mediator
    }
  }
`;
